import React, { createContext, useState } from 'react';
import type { ModalContextType, ModalProviderProps } from '../types';

// eslint-disable-next-line react-refresh/only-export-components
export const ModalContext = createContext<ModalContextType | undefined>(
  undefined
);

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [modalClickedFrom, setModalClickedFrom] = useState<string | undefined>(
    undefined
  );
  const [isDonationModalOpen, setIsDonationModalOpen] = useState(false);

  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
  };

  const openDonationModal = () => {
    setIsDonationModalOpen(true);
  };

  const closeDonationModal = () => {
    setIsDonationModalOpen(false);
  };

  const value: ModalContextType = {
    modalClickedFrom,
    setModalClickedFrom,
    isContactModalOpen,
    openContactModal,
    closeContactModal,
    isDonationModalOpen,
    openDonationModal,
    closeDonationModal,
  };

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};
